var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRestore = function SvgRestore(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "14px",
    viewBox: "0 0 16 14",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Combined Shape")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.14285714,3.46389584e-14 C12.9295357,3.46389584e-14 16,3.07046429 16,6.85714286 C16,10.6438214 12.9295357,13.7142857 9.14285714,13.7142857 C7.57332143,13.7142857 6.12953571,13.1809643 4.97142857,12.2895357 L4.97142857,12.2895357 L6.04953571,11.1961786 C6.92571429,11.8209286 7.98857143,12.1904643 9.14285714,12.1904643 C12.0876071,12.1904643 14.4761786,9.80189286 14.4761786,6.85714286 C14.4761786,3.91239286 12.0876071,1.52382143 9.14285714,1.52382143 C6.19810714,1.52382143 3.80953571,3.91239286 3.80953571,6.85714286 L3.80953571,6.85714286 L6.09525,6.85714286 L3.04760714,9.90475 L0,6.85714286 L2.28571429,6.85714286 C2.28571429,3.07046429 5.35617857,3.46389584e-14 9.14285714,3.46389584e-14 Z M9.14285714,5.33332143 C9.98478571,5.33332143 10.6666786,6.01525 10.6666786,6.85714286 C10.6666786,7.69903571 9.98478571,8.38096429 9.14285714,8.38096429 C8.30092857,8.38096429 7.61903571,7.69903571 7.61903571,6.85714286 C7.61903571,6.01525 8.30092857,5.33332143 9.14285714,5.33332143 Z",
    id: "Combined-Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRestore, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/restore.dfe428e2.svg";
export { ForwardRef as ReactComponent };